import { DatePicker as AntDatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { DATE_INPUT_DISPLAY_FORMAT } from 'api/models';
import {
  BackgroundColor,
  InputBorder,
  InputFocus,
} from 'components/atoms/input/input';

const Picker = forwardRef<any, DatePickerProps>((props, ref) => {
  return (
    <AntDatePicker ref={ref} format={DATE_INPUT_DISPLAY_FORMAT} {...props} />
  );
});

export const DatePicker = styled(Picker)<DatePickerProps>`
  ${InputBorder};
  ${BackgroundColor};
  padding: 0 var(--spacing-05);
  &.ant-picker-disabled {
    opacity: 0.5;
  }
  &.ant-picker-focused {
    ${InputFocus};
  }
`;
